// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager_pager__2YGlj","prev":"pager_prev__3BHe-","next":"pager_next__2EDIi","active":"pager_active__1Br-2"};